import { Component } from '@angular/core';
import { nodeType } from 'src/app/core/constants/constants';
import { ConnectionCreated, NodeConnectionData } from 'src/app/core/interface/flow-builder.interface';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-join-node',
  templateUrl: './join-node.component.html',
  styleUrls: ['./join-node.component.scss']
})
export class JoinNodeComponent {

  public isCheckedAll: boolean = false;
  public dropdownConfig: { displayKey: string; search: boolean; clearOnSelection: boolean; placeholder: string; height: string; } = {
    displayKey: 'key',
    search: true,
    clearOnSelection: true,
    placeholder: '-',
    height: '250px'
  };
  nulll =undefined;
  nulll2 =undefined;

  public leftData: any;
  public rightData: any;
  private subs: SubSink = new SubSink();
  
  constructor(
    public _fb: FlowBuilderService)
    {
      this.subs.add(
        this._fb.nodeConnectionCreated$.subscribe((res: ConnectionCreated) => {
          if (+res.input_id === this._fb?.activeNode?.id) {
            this.checkForConnectionData();
          }
        })
      );
    }

    ngOnInit(): void {
      this.checkForConnectionData();
      this.subs.add(
        this._fb?.nodeConnectionCreated$?.subscribe((res: ConnectionCreated) => {
          if (+res?.input_id === this._fb?.activeNode?.id) {
            this.checkForConnectionData();
          }
        })
      );
    }
   
    checkForConnectionData() {
      const nodeDetailsById = this._fb?.editor?.getNodeFromId(this._fb?.activeNode?.id);
      let sourceNodeIndex: any;
      if (nodeDetailsById?.inputs['input_1']?.connections?.length !== 0) {
        sourceNodeIndex = this._fb?.drawnNodeList?.findIndex((x: string | any) => x?.id?.toString() === nodeDetailsById?.inputs['input_1']?.connections[0]?.node?.toString());
  
  
        this.setTableHeaderNode_1(this._fb?.drawnNodeList[sourceNodeIndex]);
  
      }
      if (nodeDetailsById?.inputs['input_2']?.connections?.length !== 0) {
        sourceNodeIndex = this._fb.drawnNodeList?.findIndex((x: string | any) => x.id.toString() === nodeDetailsById?.inputs['input_2']?.connections[0]?.node.toString());
        this.setTableHeaderNode_2(this._fb?.drawnNodeList[sourceNodeIndex]);
      }
  
    }

  
    setTableHeaderNode_1(sourceNode: NodeConnectionData|any) {

      try {
        const activeNode = this._fb?.activeNode;
        const key:any = [];
  
        if (!activeNode.connection) {
          activeNode.connection = {};
        }
  
        if (sourceNode?.name==nodeType?.join){
          activeNode.LeftJoinFormat =sourceNode['tempJoinResult'];
          return;
  
        }
  
        switch (sourceNode?.name) {
          case nodeType?.select:

            if (sourceNode?.connection?.gridData && sourceNode?.reFormat !== undefined) {
              sourceNode?.reFormat?.forEach((element: { updatedName: string, checked: boolean, originalName: string }) => {
                if ((element?.updatedName === null || element?.updatedName === undefined) && element?.checked) {
                  key?.push(element?.originalName);
                } else if ((element?.updatedName !== null || element?.updatedName !== undefined) && element?.checked) {
                  key?.push(element?.updatedName);
                }

              });

              activeNode.LeftJoinFormat = [];

              if (!activeNode['tempLeftJoinFormat']) {
                activeNode['tempLeftJoinFormat'] = activeNode?.LeftJoinFormat;
                key?.forEach((item: string, i: number) => {
                  activeNode?.LeftJoinFormat?.push({ key: key[i], value: key[i], checked: true });
                });
              } else {
                activeNode.LeftJoinFormat = activeNode?.tempLeftJoinFormat;
              }



            } else {
              const unchecked = this._fb?.activeNode?.reFormat?.filter((x: { checked: boolean }) => !x?.checked);
              this.isCheckedAll = unchecked?.length !== 0 ? false : true;
            }


            activeNode.connection = sourceNode?.connection;
            break;

          case nodeType?.filter:
            sourceNode?.filterFormat?.forEach((element: { value: string }) => {
              key?.push(element?.value);
            });

            activeNode.LeftJoinFormat = [];
            if (!activeNode['tempLeftJoinFormat']) {
              activeNode['tempLeftJoinFormat'] = activeNode?.LeftJoinFormat;
              for (let i = 0; i < key?.length; i++) {
                activeNode?.LeftJoinFormat?.push({ key: key[i], value: key[i], checked: true });
              }
            } else {
              activeNode.LeftJoinFormat = activeNode?.tempLeftJoinFormat;
            }
            activeNode.connection = sourceNode?.connection;

            break;

          case nodeType?.source:

            if (sourceNode?.connection?.gridData !== undefined) {
              activeNode.LeftJoinFormat = [];
              activeNode.connection.gridData = sourceNode?.connection?.gridData;
              const data = Object.keys(sourceNode?.connection?.gridData[0]);
              if (!activeNode['tempLeftJoinFormat']) {
                activeNode['tempLeftJoinFormat'] = activeNode?.LeftJoinFormat;
                data?.forEach((item: string, i: number) => {
                  activeNode?.LeftJoinFormat?.push({ key: data[i], value: data[i], checked: true });
                });
              } else {
                activeNode.LeftJoinFormat = activeNode?.tempLeftJoinFormat;
              }
            }

          break;
          default:
            break;
        }
      } catch (error) {
        return;
      }
    }
  
  
    setTableHeaderNode_2(sourceNode: NodeConnectionData|any) {
      try {
        const activeNode = this._fb?.activeNode;
        const key:any[] = [];
  
        if (!activeNode.connection) {
          activeNode.connection = {};
        }
  
        if (sourceNode?.name==nodeType?.join){
          activeNode.RightJoinFormat =sourceNode['tempJoinResult'];
          return;
        }
        switch (sourceNode?.name) {
        case nodeType?.select:
          if (sourceNode?.connection?.gridData && sourceNode?.reFormat !== undefined) {
            sourceNode?.reFormat?.forEach((element: { updatedName: string, checked: boolean, originalName: string }) => {
              if ((element?.updatedName === null || element?.updatedName === undefined) && element?.checked) {
                key?.push(element?.originalName);
              } else if ((element?.updatedName !== null || element?.updatedName !== undefined) && element?.checked) {
                key?.push(element?.updatedName);
              }
  
            });
            activeNode.RightJoinFormat = [];
            if (!activeNode['tempRightJoinFormat']){
              activeNode['tempRightJoinFormat']=activeNode.RightJoinFormat;
              key?.forEach((item: string, i:number)=>{
                activeNode?.RightJoinFormat?.push({ key: key[i], value: key[i], checked: true });
              });
            } else {
              activeNode.RightJoinFormat= activeNode?.tempRightJoinFormat;
            }
          } else {
            const unchecked = this._fb?.activeNode?.reFormat?.filter((x: { checked: boolean }) => !x?.checked);
            this.isCheckedAll = unchecked?.length !== 0 ? false : true;
          }
          activeNode.connection = sourceNode?.connection;
          break;
        case nodeType?.filter:
          sourceNode?.filterFormat?.forEach((element: { value: string }) => {
            key?.push(element?.value);
          });
  
          activeNode.RightJoinFormat = [];
          if (!activeNode['tempRightJoinFormat']){
            activeNode['tempRightJoinFormat']=activeNode?.RightJoinFormat;
            key?.forEach((item: string, i:number)=>{
              activeNode?.RightJoinFormat?.push({ key: key[i], value: key[i], checked: true });
            });
          } else {
            activeNode.RightJoinFormat= activeNode?.tempRightJoinFormat;
          }
          activeNode.connection = sourceNode?.connection;
          break;
  
        case nodeType?.source:

          if (sourceNode?.connection?.gridData !== undefined) {
            activeNode.connection.gridData = sourceNode?.connection?.gridData;
            const data = Object.keys(sourceNode?.connection?.gridData[0]);
            activeNode.RightJoinFormat = [];
            if (!activeNode['tempRightJoinFormat']){
              activeNode['tempRightJoinFormat']=activeNode?.RightJoinFormat;
              data?.forEach((item: string, i:number)=>{
                activeNode?.RightJoinFormat?.push({ key: data[i], value: data[i], checked: true });
              });
            } else {
              activeNode.RightJoinFormat= activeNode?.tempRightJoinFormat;
            }
  
          }
         break;
  
        default:
          break;
        }
  
      } catch (error) {
        return;
      }
    }

    itemCollaps(i:number,type:string){
      if(type ==='l'){
        let val = this._fb.activeNode?.LeftJoinFormat[i]['isCheck']
        this._fb.activeNode?.LeftJoinFormat.forEach((element:any,j:number) => {
          if(i!==j){
            element['isCheck'] = false
          }
        });
        this._fb.activeNode.LeftJoinFormat[i]['isCheck'] = val===undefined ? true : !val;
      }
      else{
        let val = this._fb.activeNode?.RightJoinFormat[i]['isCheck']
        this._fb.activeNode?.RightJoinFormat.forEach((element:any,j:number) => {
          if(i!==j){
            element['isCheck'] = false
          }
        });
        this._fb.activeNode.RightJoinFormat[i]['isCheck'] = val===undefined ? true : !val;
      }
    }

  LeftDataChange(value:any) {
    
    this._fb.activeNode.leftDataSelected = value;
    this._fb.activeNode.leftData = value?.value;
  }

  RightDataChange(value:any) {
    this._fb.activeNode.rightDataSelected = value;
    this._fb.activeNode.rightData = value?.value;
  }

  lft_UpdateCheckbox(index: number) {
    this._fb.activeNode.LeftJoinFormat[index].checked = !this._fb?.activeNode?.LeftJoinFormat[index]?.checked;
    const unchecked = this._fb?.activeNode?.LeftJoinFormat?.filter((x: { checked: boolean }) => !x?.checked);
    this.isCheckedAll = unchecked?.length !== 0 ? false : true;
  }

  rght_UpdateCheckbox(index: number) {
    this._fb.activeNode.RightJoinFormat[index].checked = !this._fb.activeNode?.RightJoinFormat[index]?.checked;
    const unchecked = this._fb.activeNode?.RightJoinFormat?.filter((x: { checked: boolean }) => !x?.checked);
    this.isCheckedAll = unchecked?.length !== 0 ? false : true;
  }

  updateAllCheckbox() {
    this.isCheckedAll = !this?.isCheckedAll;
    this._fb.activeNode?.LeftJoinFormat?.map((value: { checked: boolean }) => value.checked = this?.isCheckedAll);
    this._fb.activeNode?.RightJoinFormat?.map((value: { checked: boolean }) => value.checked = this?.isCheckedAll);
  }
}
